import { useState } from 'react';

export enum PostPopups {
  Schedule = 'schedule',
  ScheduleDarkPost = 'schedule-darkPost',
  SchedulePublishNow = 'schedule-publishNow',
  ScheduleExportInAdvance = 'schedule-exportInAdvance',
  InternalApproval = 'internal-approval',
  ClientApproval = 'client-approval',
  AssignTask = 'assign-approval',
}

export function usePostPopups() {
  const [activePopup, setActivePopup] = useState<PostPopups>();

  function showPopup(popup: PostPopups) {
    setActivePopup(popup);
  }

  function hidePopup() {
    setActivePopup(undefined);
  }

  return {
    isActive: !!activePopup,
    activePopup,
    showPopup,
    hidePopup,
  };
}
